/**
 * Match type for role checking
 */
export enum MatchType {
  Any = 'any',      // User has at least one of the required roles
  All = 'all',      // User has all required roles
  Exact = 'exact',  // User has exactly the required roles (no more, no less)
}
